import { render, staticRenderFns } from "./index.vue?vue&type=template&id=32c3e0da&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=32c3e0da&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c3e0da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32c3e0da')) {
      api.createRecord('32c3e0da', component.options)
    } else {
      api.reload('32c3e0da', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=32c3e0da&scoped=true", function () {
      api.rerender('32c3e0da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/billing/invoiceReview/index.vue"
export default component.exports